<template>
    <div v-if="atendimento">
        <div class="small text-primary mb-1">Balanço Hídrico</div>

        <div class="form-row mb-2"> 
            <div class="col col-md-6">
                <az-periodo v-model="filtros" :sync="true" @sync="load(false)" />
            </div>

            <div class="col col-12 col-md-6">
                <az-input 
                    icon="fa fa-search fa-fw"
                    type="text"
                    placeholder="Pesquisar..."
                    v-model="filtros.pesquisa">
                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="!viewonly">
                            <button class="btn btn-outline-primary" type="button" @click="incluir()">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && exibicao && exibicao.length"></div>
            <div class="determinate" v-else></div>
        </div>

        <div v-if="exibicao && !exibicao.length">
            <az-empty-state 
                :icon="firstLoad ? 'fa-solid fa-water' : 'fas fa-sync-alt'" 
                :msg="firstLoad ? 'Nenhuma registro de balanço encontrado.' : 'Clique no ícone para atualizar a busca.'"
                :action="firstLoad ? '' : 'Buscar'"
                :method="load"></az-empty-state>
        </div>
        
        <div v-else>
            <table class="table table-sm table-hover small">
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Hora</th>
                        <th>Responsável</th>
                        <th>Descrição</th>
                        <th>Obs</th>
                        <th class="text-right">Qtde (ml)</th>
                        <th class="text-right">Saldo</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(blo, ibx) in exibicao" :key="ibx">
                        <td>
                            <a href="#" @click.prevent="editar(blo)" class="card-link text-nowrap" v-if="blo.id_balanco_hidrico">
                                {{ $util.getFormatDate(blo.dt_registro) }}
                            </a>
                        </td>
                        <td>
                            <template v-if="blo.id_balanco_hidrico">
                                {{ blo.dt_registro.slice(11,16) }}
                            </template>
                        </td>
                        <td>
                            <template v-if="blo.usuario">{{ blo.usuario.st_login }}</template>
                        </td>
                        <td>
                            <template v-if="blo.item">{{ blo.item.search }}</template>
                        </td>
                        <td>
                            {{ blo.st_obs }}
                        </td>
                        <td class="text-nowrap text-right">
                            <template v-if="blo.id_balanco_hidrico">
                                {{ $util.formatMoeda(blo.dc_quantidade, 4, 0) }}
                                <i class="fa-solid fa-circle-plus text-success ml-1" v-if="blo.item.in_fator > 0"></i>
                                <i class="fa-solid fa-circle-minus text-danger ml-1" v-else-if="blo.item.in_fator < 0"></i>
                            </template>
                        </td>
                        <td class="text-nowrap text-right">
                            {{ $util.formatMoeda(blo.saldo, 4, 0) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Edição -->
        <div class="modal fade" id="balancoHidricoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Balanço Hídrico
                            <span class="badge badge-secondary">{{ edicao.id_balanco_hidrico ? '#' + edicao.id_balanco_hidrico : 'Novo' }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-4">
                                <az-input 
                                    label="Data/Hora"
                                    type="datetime-local"
                                    step="60"
                                    :edicao="!edicao.id_balanco_hidrico"
                                    required
                                    :validate="validate"
                                    v-model="edicao.dt_registro" />
                            </div>
                            <div class="col col-12 col-md-8" v-if="edicao.usuario">
                                <az-input 
                                    label="Responsável"
                                    :edicao="false"
                                    v-model="edicao.usuario.st_login" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12 col-md-4">
                                <az-input 
                                    label="Quantidade"
                                    type="number"
                                    :edicao="!edicao.id_balanco_hidrico || ( edicao.id_usuario == $store.state.user.id_usuario )"
                                    required
                                    :validate="validate"
                                    v-model="edicao.dc_quantidade">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <span class="input-group-text">ml</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-8">
                                <az-input 
                                    v-if="!edicao.id_balanco_hidrico"
                                    label="Item"
                                    type="select"
                                    optionsMode="aql"
                                    service="balanco_items.index"
                                    required
                                    :validate="validate"
                                    v-model="edicao.item">
                                    <template v-slot:buttonposb v-if="edicao.item && edicao.item.in_fator">
                                        <div class="input-group-append">
                                            <span class="input-group-text">
                                                <i class="fa-solid fa-circle-plus text-success" v-if="edicao.item.in_fator > 0"></i>
                                                <i class="fa-solid fa-circle-minus text-danger" v-else-if="edicao.item.in_fator < 0"></i>
                                            </span>
                                        </div>
                                    </template>
                                </az-input>

                                <az-input 
                                    v-else
                                    label="Item"
                                    :edicao="false"
                                    v-model="edicao.item.search">
                                    <template v-slot:buttonposb v-if="edicao.item && edicao.item.in_fator">
                                        <div class="input-group-append">
                                            <span class="input-group-text">
                                                <i class="fa-solid fa-circle-plus text-success" v-if="edicao.item.in_fator > 0"></i>
                                                <i class="fa-solid fa-circle-minus text-danger" v-else-if="edicao.item.in_fator < 0"></i>
                                            </span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input 
                                    label="Observação"
                                    type="textarea"
                                    rows="3"
                                    :validate="validate"
                                    v-model="edicao.st_obs" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">{{ edicao.id_balanco_hidrico ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            filtros: {
                inicio: null,
                fim: null, 
                periodo: "h", 
                pesquisa: "", 
            },
            firstLoad: false,
            dados: [],
            edicao: null, 
            validate: false, 
        };
    },

    props: ['atendimento', 'viewonly'], 
    
    components: {
        AzInput,
        AzPeriodo,
        AzSubmit,
    },

    computed: { 
        exibicao: function () { 
            let pesquisar = this.filtros.pesquisa.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            if ( this.edicao_datas ) {
                return [ 
                    this.edicao_datas, 
                ];
            }

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( !this.filtros.pesquisa || reg.test(JSON.stringify(item)) );
                }) : null;
        }
    },

    methods: { 
        set_periodo (inicio, fim) { 
            this.filtros.periodo = ""; 
            this.filtros.inicio = inicio ? inicio.slice(0,10) : this.$util.hoje(); 
            this.filtros.fim = fim ? fim.slice(0,10) : this.$util.hoje(); 
        },

        editar (blo) { 
            this.validate = false; 
            this.edicao = _.cloneDeep(blo);

            $('#balancoHidricoModal').modal('show');
        },

        incluir () { 
            this.validate = false; 

            this.edicao = { 
                id_balanco_hidrico: null, 
                id_paciente: this.atendimento.id_paciente,
                id_internacao: this.atendimento.id_internacao,
                dt_registro: this.$util.hoje_com_hora(),
                item: "", 
                dc_quantidade: "",  
                st_obs: "", 
            };

            $('#balancoHidricoModal').modal('show');
        },

        atualizar () { 
            if ( this.edicao && this.edicao.item && !this.edicao.id_balanco_hidrico ) { 
                this.edicao.id_balanco_item = this.edicao.item.id_balanco_item;
            }

            this.$util.atualizar(this, { 
                service: 'balanco_hidricos', 
                func: 'store',
                dados: { 
                    ...this.edicao,
                    ...this.filtros, 
                },
                modal: 'balancoHidricoModal',
                toast: true, 
                callback: () => { 
                    this.load(); 
                }
            });
        },

        load() { 
            this.firstLoad = true; 

            this.$util.load(this, { 
                service: 'balanco_hidricos', 
                func: 'index',
                parms: { 
                    id_paciente: this.atendimento.id_paciente,
                    id_internacao: this.atendimento.id_internacao,
                    ...this.filtros,
                },
                loadTo: res => { 
                    this.dados = res; 
                }
            });
        },

        init() { 
            if ( !this.firstLoad ) { 
                this.load(); 
            }
        }

    }
    
}
</script>
